// extracted by mini-css-extract-plugin
export var body = "_h9-0";
export var sectionHeader = "_h9-4";
export var shortcutColumns = "_h9-2";
export var shortcutList = "_h9-1";
export var shortcutSection = "_h9-3";